import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, getTopBetsService } from 'games/BalloonGame/balloonPumpGame.service'

export const getMyBets = createAsyncThunk('football/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getTopBets = createAsyncThunk('football/topBets', async (params, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
